import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FranceConnectComponent } from './france-connect.component';

// `HttpClientModule` n'est volontairement importé que dans `AppModule` (cf. AppUploadFilesModule).
@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [FranceConnectComponent],
  exports: [FranceConnectComponent],
})
export class FranceConnectModule { }



// WEBPACK FOOTER //
// ./src/app/components/france-connect/france-connect.module.ts